module.exports = __webpack_public_path__ + "img/size6.907e7da7.png";